export default __webpack_public_path__ + "guide-access-elevation-data-example-response-480-5d089b858ea7926579c1d0d8c33a5121.webp";